/**
 * EdgeStreamProvider Component
 *
 * Provides EdgeStream instance to React app via context
 */

import React from 'react';
import type { IEdgeStream } from '../types';
import { EdgeStreamContext, type EdgeStreamContextValue } from './EdgeStreamContext';

export interface EdgeStreamProviderProps {
  stream: IEdgeStream;
  children: React.ReactNode;
}

export function EdgeStreamProvider({ stream, children }: EdgeStreamProviderProps): React.ReactElement {
  const value: EdgeStreamContextValue = { stream };

  React.useEffect(() => {
    // Start stream when provider mounts
    stream.start().catch((error) => {
      console.error('Failed to start EdgeStream:', error);
    });

    // Stop stream when provider unmounts
    return () => {
      stream.stop().catch((error) => {
        console.error('Failed to stop EdgeStream:', error);
      });
    };
  }, [stream]);

  return React.createElement(EdgeStreamContext.Provider, { value }, children);
}
